import { sessionActions } from './session';
import { devicesActions } from './devices';

const threshold = 3;    // Oficial: 3 actions per second
const minInterval = 1500; // Oficial: 1500ms
// 2ECOMP: Reduzido de 30s para 10s para menor latência
const maxInterval = 10000;
const scaleFactor = 1000;

 
const debugMode = false; // Desabilitado para produção
const debugLog = (message) => debugMode && console.log(message);

export default () => (next) => {
  const deviceBuffer = new Map();
  // 2ECOMP CRITICAL: Array para ACUMULAR todas as posições (não sobrescrever)
  // Garante que nenhuma posição seja perdida para o trail/rota no mapa
  let positionBuffer = [];
  let throttled = false;
  let counter = 0;
  let currentInterval = minInterval;

  const flush = () => {
    const start = performance.now();

    const devices = Array.from(deviceBuffer.values());
    // 2ECOMP: Copia o array e limpa imediatamente
    const positions = positionBuffer;
    positionBuffer = [];

    let devicesTime = 0;
    let positionsTime = 0;

    if (devices.length > 0) {
      const t0 = performance.now();
      next({ type: devicesActions.update.type, payload: devices });
      devicesTime = performance.now() - t0;
      deviceBuffer.clear();
    }

    if (positions.length > 0) {
      const t0 = performance.now();
      next({ type: sessionActions.updatePositions.type, payload: positions });
      positionsTime = performance.now() - t0;
    }

    const totalTime = performance.now() - start;
    // 2ECOMP: Log detalhado para debug de performance
    debugLog(`Flush: ${devices.length} devices (${devicesTime.toFixed(1)}ms) + ${positions.length} positions (${positionsTime.toFixed(1)}ms) = ${totalTime.toFixed(1)}ms`);
    currentInterval = Math.min(Math.max(totalTime * scaleFactor, minInterval), maxInterval);
  };

  const tick = () => {
    if (throttled) {
      flush();
    }

    const shouldThrottle = (counter * 1000 / currentInterval) > threshold;
    if (throttled !== shouldThrottle) {
      debugLog(`Throttling ${shouldThrottle}`);
      throttled = shouldThrottle;
    }
    counter = 0;
    if (!throttled) currentInterval = minInterval;
    setTimeout(tick, currentInterval);
  };

  setTimeout(tick, currentInterval);

  // 2ECOMP: Set de tipos de ação throttleados (O(1) lookup)
  // NOTA: Eventos NÃO são throttleados - cada evento é importante e único
  const throttledTypes = new Set([
    devicesActions.update.type,
    sessionActions.updatePositions.type,
  ]);

  // 2ECOMP: Função para bufferizar ação por tipo
  const bufferAction = (action) => {
    if (action.type === devicesActions.update.type) {
      // Devices: Map (última versão por device é suficiente)
      action.payload.forEach((item) => deviceBuffer.set(item.id, item));
    } else if (action.type === sessionActions.updatePositions.type) {
      // Positions: Array (TODAS as posições são importantes para o trail)
      positionBuffer.push(...action.payload);
    }
  };

  return (action) => {
    // Early exit para ações não throttleadas (inclui eventos)
    if (!throttledTypes.has(action.type)) {
      return next(action);
    }

    counter += 1;

    if (throttled) {
      bufferAction(action);
      return;
    }

    if ((counter * 1000 / currentInterval) > threshold) {
      if (!throttled) debugLog(`Throttling started`);
      throttled = true;
      bufferAction(action);
      return;
    }

    return next(action);
  };
};